<template>
    <v-card style="box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25)" class="d-flex flex-column">
        <v-layout pa-3 class="titleCard" :style="{'background':barcolor}" style="flex: 0">
            <v-flex shrink class="d-flex align-center">
                <v-icon large class="white--text mr-3">bar_chart</v-icon>
            </v-flex>
            <v-flex class="text-left" style="font-size: 20px">
                {{ title }}
            </v-flex>
        </v-layout>
        <v-layout pa-7 style="flex: 1">
            <v-flex>
                <div class="mb-3 text-left">หน่วย: {{ unit }}</div>
                <BarChart
                        :dataname="dataname"
                        :chartdata="chartdata"
                        :options="options"
                ></BarChart>
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
    import BarChart from './BarChart'

    export default {
        name: "CardBarChart",
        components: {
            BarChart
        },
        props: ['title','chartdata','options','unit','dataname','barcolor'],
    }
</script>

<style scoped>

    .titleCard {
        color: #FFFFFF;
    }
    .titleCardGrey {
        background: #4F4F4F;
        color: #FFFFFF;
    }


</style>
